// Compra Recorrente (feature 007): desligada por padrão; com a flag ligada, o
// acesso ainda depende de paciente logado e do piloto informado pelo serviço.
export const isRecurrencyEnabled = () => import.meta.env.VITE_FEATURE_RECURRENCY === 'true'
